import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const resultsHeader: {
	container: SxProps<Theme>;
	searchTermTitle: (isCategoryPage: boolean) => SxProps<Theme>;
} = {
	container: {
		ml: { sm: '10px' },
	},
	searchTermTitle: (isCategoryPage) => ({
		display: { sm: 'block', md: 'inline-block' },
		color: 'grey.500',
		fontWeight: isCategoryPage ? OpenSansFontWeights.semibold : OpenSansFontWeights.regular,
		mr: '10px',
		'&::first-letter': {
			textTransform: 'uppercase',
		},
		b: {
			fontWeight: OpenSansFontWeights.semibold,
		},
	}),
};
